import * as React from 'react';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';
import {ReportType} from '../../../Models/EnumTypes/ReportEnumTypes';

type P = {
    t?: i18next.TFunction,
    reportType?: ReportType
};
type S = {
    //
};

class ReportActiveTerminalsManual extends React.Component<P, S> {
    public render() {
        const {t, reportType} = this.props;
        return (
            <div className="report report-manual">
                <p className="report-manual__title">{t('reportManual')}</p>
                <ol className="report-manual__list">
                    <li className="report-manual__list-item"
                        dangerouslySetInnerHTML={{__html: t('reportManualStep1a')}}/>
                    <li className="report-manual__list-item"
                        dangerouslySetInnerHTML={{__html: t('reportManualStep2a')}}/>
                    <li className="report-manual__list-item"
                        dangerouslySetInnerHTML={{__html: t('reportManualStep4')}}/>
                </ol>
            </div>
        );
    }
}

export default withTranslation('reports')(ReportActiveTerminalsManual as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/ReportsComposites/ReportActiveTerminalsManual.tsx